import apiClient from './apiClient';

// Σχόλια και αξιολογήσεις (ΛΑ-16, ΛΑ-17).
//
// **Δικό του module** και όχι νέες μέθοδοι στο `auth.service.js`: εκείνο ανήκει στο
// P1-5 κατά τον κανόνα ιδιοκτησίας των τριών παράλληλων κλάδων, και τρεις κλάδοι
// που προσθέτουν μεθόδους στο ίδιο αρχείο συγκρούονται στην ίδια περιοχή. Νέο
// αρχείο δεν συγκρούεται ποτέ. Ο μεταφορέας παραμένει ο υπάρχων `apiClient`.
//
// **Η συλλογή είναι υποχρεωτική σε κάθε κλήση.** Με την D9 ο πόρος είναι κοινός σε
// πολλές συλλογές, ενώ η κρίση ανήκει στη σχέση πόρου και συλλογής (ΛΑ-17: «για το
// αντικείμενο της συλλογής»). Κλήση χωρίς συλλογή δεν έχει νόημα, και το API την
// απορρίπτει· η υπογραφή το κάνει ορατό πριν φτάσει εκεί.

function assertCollection(collectionId) {
    if (!collectionId) {
        throw new Error('Οι κρίσεις είναι ανά συλλογή: λείπει το αναγνωριστικό συλλογής.');
    }
}

export function getComments(resourceId, collectionId) {
    assertCollection(collectionId);
    return apiClient.getPage(`/api/resources/${resourceId}/comments?collection=${collectionId}`);
}

export function addComment(resourceId, collectionId, text) {
    assertCollection(collectionId);
    return apiClient.post(`/api/resources/${resourceId}/comments`, {
        collection: collectionId,
        text
    });
}

export function getRatings(resourceId, collectionId) {
    assertCollection(collectionId);
    return apiClient.getPage(`/api/resources/${resourceId}/ratings?collection=${collectionId}`);
}

/**
 * Καταγράφει ή **ενημερώνει** την εκτίμηση του συνδεδεμένου χρήστη.
 *
 * Μία διαδρομή και για τα δύο, γιατί η **D14** ορίζει μία αξιολόγηση ανά χρήστη,
 * ανά πόρο, ανά συλλογή: η δεύτερη υποβολή είναι μεταβολή γνώμης και όχι δεύτερη
 * γνώμη. Το API απαντά 201 στη δημιουργία και 200 με `meta.updated` στη μεταβολή.
 */
export function saveRating(resourceId, collectionId, { relevance, justification }) {
    assertCollection(collectionId);
    return apiClient.post(`/api/resources/${resourceId}/ratings`, {
        collection: collectionId,
        relevance,
        justification: justification || undefined
    });
}

export default { getComments, addComment, getRatings, saveRating };
